import { FunctionComponent } from "react";
import { Avatar as MuiAvatar } from "@mui/material";

import { avatarFill, BRAND, RADIUS, SURFACE } from "@/theme/tokens";

interface AvatarProps {
	firstName?: string;
	lastName?: string;
	imageSrc?: string;
}

export const Avatar: FunctionComponent<AvatarProps> = ({ firstName, lastName, imageSrc }) => {
	const initials =
		firstName && lastName
			? `${firstName.split("")[0].toUpperCase()}${lastName.split("")[0].toUpperCase()}`
			: "";

	// One of the six avatar fills, picked stably from the name so the same person keeps
	// the same colour. Deliberately never the accent (guide §2.6) — an avatar is not a
	// call to action, and a wall of orange circles drowns the one button that is.
	return (
		<MuiAvatar
			src={imageSrc}
			sx={{
				height: 44,
				width: 44,
				cursor: "pointer",
				borderRadius: RADIUS.card,
				backgroundColor: initials ? avatarFill(initials) : SURFACE.alt,
				color: initials ? BRAND.white : BRAND.subtle,
				fontWeight: 700,
			}}
		>
			{initials}
		</MuiAvatar>
	);
};
